import { createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import * as taskTypeFormTypes from './taskTypeFormTypes';

export const onProcessTypeSelected = createAction(taskTypeFormTypes.PROCESS_TYPE_SELECTED, processTypeId => ({
  processTypeId,
}));
export const onAddButtonClicked = createAction(taskTypeFormTypes.ADD_BUTTON_CLICKED);
export const submitTaskTypeForm = createFormAction(taskTypeFormTypes.SUBMIT_TASKTYPE_FORM);
